import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { FileRecord } from "../FileRecord";

import { fileQueryKeys } from "./fileQueryKeys";

/**
 * The files of an association that have one of `extensions`, in any folder,
 * ordered by path and capped at the first page of matches (see
 * `FileService.getFilesWithExtensions`). Disabled while `associationId` is
 * undefined.
 */
export function useFilesWithExtensions(
  associationId: string | undefined,
  extensions: readonly string[],
  resourceOwnerId: string | undefined,
) {
  const { files } = useDomainServices();

  return useQuery<FileRecord[], Error>({
    queryKey: fileQueryKeys.withExtensions(associationId ?? "", extensions),
    queryFn: ({ signal }) => {
      if (associationId === undefined) {
        return Promise.reject(new Error("Invalid associationId"));
      }
      return files.getFilesWithExtensions(associationId, [...extensions], {
        abortSignal: signal,
        resourceOwnerId,
      });
    },
    enabled: associationId !== undefined,
  });
}
